import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="calculators-route"
        path="/calculators"
        component={Page} />
];

export default Routes;